import { useEffect, useRef } from "react";
import { useQueryClient } from "react-query";
import { useLocation } from "react-router-dom";

const ClearCacheOnRouteChange = () => {
  const location = useLocation();
  const queryClient = useQueryClient();

  const prevPathRef = useRef<string>(location.pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const currentPath = location.pathname;

    const wasAdmin = prevPath.startsWith("/admin");
    const isAdmin = currentPath.startsWith("/admin");

    if (wasAdmin !== isAdmin) {
      queryClient.clear();
    }

    prevPathRef.current = currentPath;
  }, [location.pathname, queryClient]);

  return null;
};

export default ClearCacheOnRouteChange;
